import React from "react";
import {
  IonMenu,
  IonContent,
  IonButton,
  IonIcon,
  IonLabel,
  IonHeader,
  IonToolbar,
  IonBadge,
  IonMenuToggle
} from "@ionic/react";
import { arrowForward, close } from "ionicons/icons";
import { Link } from "react-router-dom";
import "tailwindcss/tailwind.css";
import { signOutAuth } from "../lib/firebase";
import { useUsersStore } from "../stores/users.store";

const Menu: React.FC = () => {
  const unreadActivity = useUsersStore(state => state.unreadActivity || 0);
  return (
    <IonMenu
      side="end"
      menuId="first"
      contentId="menuContent"
      className="menu-custom w-[400px] ml-auto"
    >
      <IonMenuToggle>
        <IonHeader>
          <IonToolbar color="transparent" className="px-2">
            <IonButton fill="solid" size="small" slot="end" color="primary">
              <IonIcon icon={close} className="text-black" />
            </IonButton>
          </IonToolbar>
        </IonHeader>
        <IonContent
          fullscreen
          scroll-y="false"
          className="content-transparent ion-padding"
        >
          <div className="flex justify-between items-center px-4 py-2">
            <Link
              to="/activity"
              className="text-4xl block font-semibold w-full hover-scale"
            >
              Activity
            </Link>
            {unreadActivity > 0 && (
              <IonBadge color="danger" className="p-2 px-4 rounded-2xl text-lg">
                {unreadActivity}
              </IonBadge>
            )}
          </div>
          <Link
            to="/quoCoin/buy"
            className="text-4xl block px-4 font-semibold w-full hover-scale"
          >
            QuoCoin
          </Link>
          <div className="p-4 pt-4 text-3xl">
            <Link
              to="/dashboard"
              className="block py-2 font-semibold w-full hover-scale"
            >
              Dashboard
            </Link>
            <Link
              to="/coins"
              className="block py-2 font-semibold w-full hover-scale"
            >
              Coins
            </Link>
            <Link
              to="/bots"
              className="block py-2 font-semibold w-full hover-scale"
            >
              My Bots
            </Link>
            <Link
              to="/lobbies"
              className="block py-2 font-semibold w-full hover-scale"
            >
              Lobbies
            </Link>
            {/* <Link
              to="/leaderBoard"
              className="block py-2 font-semibold w-full hover-scale"
            >
              Ranking
            </Link> */}
          </div>
          <div className="px-4">
            <IonButton
              fill="clear"
              color="primary"
              className="w-52"
              routerLink="/helpCenter"
            >
              <IonIcon slot="end" icon={arrowForward} />
              <IonLabel className="font-bold">Help Center</IonLabel>
            </IonButton>
            <Link
              to="/profile"
              className="text-primary-30 text-lg font-semibold px-2 py-4 block hover-scale"
            >
              Profile & App Settings
            </Link>
            <IonButton
              fill="outline"
              className="w-52 font-bold"
              onClick={signOutAuth}
            >
              Logout
            </IonButton>
            <p className="text-sm p-2 text-primary">
              Please note that the system does not offer guarantees; use the
              tool at your own discretion and risk.
            </p>
          </div>
        </IonContent>
      </IonMenuToggle>
    </IonMenu>
  );
};

export default Menu;
